import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Privacy from "@/components/Privacy.vue";
import PrivacyTurnOn from "@/components/PrivacyTurnOn.vue";
import PrivacyMicker from "@/components/PrivacyMicker.vue";
import PrivacyAutoLauncher from "@/components/PrivacyAutoLauncher.vue";
import PrivacyAppDelete from "@/components/PrivacyAppDelete.vue";
import PrivacySettingsShortcut from "@/components/SettingsShortcut.vue";
import PrivacyBatteryChargeAlarm from "@/components/PrivacyBatteryChargeAlarm.vue";
import PrivacyNotiCatch from "@/components/PrivacyNotiCatch.vue";
import PrivacyScanRay from "@/components/PrivacyScanRay.vue";
import PrivacyWhiteNoise from "@/components/PrivacyWhiteNoise.vue";
import PrivacyAxisTrue from "@/components/PrivacyAxisTrue.vue";
import PrivacyUnitShift from "@/components/PrivacyUnitShift.vue";
import PrivacyDocScan from "@/components/PrivacyDocScan.vue";
import PrivacyPhotoCompact from "@/components/PrivacyPhotoCompact.vue";
import PrivacyTextScan from "@/components/PrivacyTextScan.vue";
import PrivacyPdfMerge from "@/components/PrivacyPdfMerge.vue";
import PrivacyImgConvert from "@/components/PrivacyImgConvert.vue";
import PrivacyAlarmEffect from "@/components/PrivacyAlarmEffect.vue";
import PrivacyNotiShare from "@/components/PrivacyNotiShare.vue";
import PrivacyNotiMaker from "@/components/PrivacyNotiMaker.vue";
import PrivacyExifWipe from "@/components/PrivacyExifWipe.vue";
import PrivacyDeviceInfo from "@/components/PrivacyDeviceInfo.vue";
import PrivacyStayAwake from "@/components/PrivacyStayAwake.vue";
import PrivacyDdayCount from "@/components/PrivacyDdayCount.vue";
import PrivacyNetScan from "@/components/PrivacyNetScan.vue";
import PrivacyHangulNandokgi from "@/components/PrivacyHangulNandokgi.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/privacy/turn-on',
    name: 'PrivacyTurnOn',
    component: PrivacyTurnOn
  },
  {
    path: '/privacy/micker',
    name: 'PrivacyMicker',
    component: PrivacyMicker
  },
  {
    path: '/privacy/auto-launcher',
    name: 'PrivacyAutoLauncher',
    component: PrivacyAutoLauncher
  },
  {
    path: '/privacy/app-delete',
    name: 'PrivacyAppDelete',
    component: PrivacyAppDelete
  },
  {
    path: '/privacy/settings-shortcut',
    name: 'SettingsShortcut',
    component: PrivacySettingsShortcut
  },
  {
    path: '/privacy/battery-charge-alarm',
    name: 'BatteryChargeAlarm',
    component: PrivacyBatteryChargeAlarm
  },
  {
    path: '/privacy/noti-catch',
    name: 'PrivacyNotiCatch',
    component: PrivacyNotiCatch
  },
  {
    path: '/privacy/scan-ray',
    name: 'PrivacyScanRay',
    component: PrivacyScanRay
  },
  {
    path: '/privacy/white-noise',
    name: 'PrivacyWhiteNoise',
    component: PrivacyWhiteNoise
  },
  {
    path: '/privacy/axis-true',
    name: 'PrivacyAxisTrue',
    component: PrivacyAxisTrue
  },
  {
    path: '/privacy/unit-shift',
    name: 'PrivacyUnitShift',
    component: PrivacyUnitShift
  },
  {
    path: '/privacy/doc-scan',
    name: 'PrivacyDocScan',
    component: PrivacyDocScan
  },
  {
    path: '/privacy/photo-compact',
    name: 'PrivacyPhotoCompact',
    component: PrivacyPhotoCompact
  },
  {
    path: '/privacy/text-scan',
    name: 'PrivacyTextScan',
    component: PrivacyTextScan
  },
  {
    path: '/privacy/pdf-merge',
    name: 'PrivacyPdfMerge',
    component: PrivacyPdfMerge
  },
  {
    path: '/privacy/img-convert',
    name: 'PrivacyImgConvert',
    component: PrivacyImgConvert
  },
  {
    path: '/privacy/alarm-effect',
    name: 'PrivacyAlarmEffect',
    component: PrivacyAlarmEffect
  },
  {
    path: '/privacy/noti-share',
    name: 'PrivacyNotiShare',
    component: PrivacyNotiShare
  },
  {
    path: '/privacy/noti-maker',
    name: 'PrivacyNotiMaker',
    component: PrivacyNotiMaker
  },
  {
    path: '/privacy/exif-wipe',
    name: 'PrivacyExifWipe',
    component: PrivacyExifWipe
  },
  {
    path: '/privacy/device-info',
    name: 'PrivacyDeviceInfo',
    component: PrivacyDeviceInfo
  },
  {
    path: '/privacy/stay-awake',
    name: 'PrivacyStayAwake',
    component: PrivacyStayAwake
  },
  {
    path: '/privacy/dday-count',
    name: 'PrivacyDdayCount',
    component: PrivacyDdayCount
  },
  {
    path: '/privacy/net-scan',
    name: 'PrivacyNetScan',
    component: PrivacyNetScan
  },
  {
    path: '/privacy/hangul-nandokgi',
    name: 'PrivacyHangulNandokgi',
    component: PrivacyHangulNandokgi
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
